export const productProductDefaultValues = { quantity: 1 };
